module.exports = __webpack_public_path__ + "static/media/alegriaasoc.civil.36402d02.png";